import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=d744f814&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=d744f814&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d744f814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d744f814')) {
      api.createRecord('d744f814', component.options)
    } else {
      api.reload('d744f814', component.options)
    }
    module.hot.accept("./Cases.vue?vue&type=template&id=d744f814&scoped=true", function () {
      api.rerender('d744f814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/institutional-trading/components/Cases.vue"
export default component.exports